export enum Layout {
    BOARD = 'BOARD',
    FOCUSED = 'FOCUSED',
    LIST = 'LIST'
}
